import {extendsAPIServices} from "./APIServices";
import getEnv from "../../helpers/common/getEnv";
import {GET} from "../../constants/HTTPConstants";

const baseAPI = getEnv('baseAPI');
const api = extendsAPIServices(baseAPI);

export const _getListHistory = ({page, limit}) => {
    return api.makeAuthRequest({
        method: GET,
        url: '/sh/histories',
        params: {
            page,
            limit,
        }
    })
}


// WEBPACK FOOTER //
// ./src/services/apis/SearchHistoryService.js